'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const UserInfo=require('../../../dist-es6/client/dtos/userInfo');let

OrganizationProfileData=function(){
function OrganizationProfileData(name,contractStartDate,serviceStartDate,serviceEndDate,primaryUserId,users,dataRetentionPeriodMs){_classCallCheck(this,OrganizationProfileData);
_.ensureInstanceOf('string',name);
_.ensureInstanceOf(Date,contractStartDate);
_.ensureInstanceOf(Date,serviceStartDate);
if(_.exists(serviceEndDate))_.ensureInstanceOf(Date,contractStartDate);
_.ensureInstanceOf(Guid,primaryUserId);
_.ensureInstanceOf(Array,users);
users.forEach(function(user){return _.ensureInstanceOf(UserInfo,user)});
_.ensureInstanceOf(['nullable','number'],dataRetentionPeriodMs);

this._name=name;
this._contractStartDate=contractStartDate;
this._serviceStartDate=serviceStartDate;
this._serviceEndDate=serviceEndDate;
this._primaryUserId=primaryUserId;
this._users=users;
this._dataRetentionPeriodMs=dataRetentionPeriodMs;
}OrganizationProfileData.prototype.





























toJSON=function toJSON(){
return{
name:this._name,
contractStartDate:this._contractStartDate.toISOString(),
serviceStartDate:this._serviceStartDate.toISOString(),
serviceEndDate:_.exists(this._serviceEndDate)?this._serviceEndDate.toISOString():null,
primaryUserId:this._primaryUserId.toString(),
users:this._users.map(function(u){return u.toJSON()}),
dataRetentionPeriodMs:this._dataRetentionPeriodMs};

};OrganizationProfileData.

fromJSON=function fromJSON(json){
return new OrganizationProfileData(
json.name,
new Date(json.contractStartDate),
new Date(json.serviceStartDate),
_.exists(json.serviceEndDate)?new Date(json.serviceEndDate):null,
Guid.fromString(json.primaryUserId),
json.users.map(function(u){return UserInfo.fromJSON(u)}),
json.dataRetentionPeriodMs);
};_createClass(OrganizationProfileData,[{key:'name',get:function(){return this._name}},{key:'contractStartDate',get:function(){return this._contractStartDate}},{key:'serviceStartDate',get:function(){return this._serviceStartDate}},{key:'serviceEndDate',get:function(){return this._serviceEndDate}},{key:'primaryUserId',get:function(){return this._primaryUserId}},{key:'users',get:function(){return this._users}},{key:'dataRetentionPeriodMs',get:function(){return this._dataRetentionPeriodMs}}]);return OrganizationProfileData}();


module.exports=OrganizationProfileData;
//# sourceMappingURL=organizationProfileData.js.map
